import type { TokenProvider } from 'aws-amplify/auth';
import { createContext } from 'react-router';

export const versionContext = createContext('dev');
export const tokenProviderContext = createContext<TokenProvider>();

export type AppRequestContexts = {
  tokenProviderContext: typeof tokenProviderContext;
  versionContext: typeof versionContext;
};
